import React, { PureComponent } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import qs from 'qs'

import FavouriteNotification from '../favourite-notification/favourite-notification'
import Icon from '../../core/patterns/icon/icon'

import i18n from '../../core/services/i18n/i18n'
import api from '../../core/services/api/api'

import styles from './favourite-button.css'
import heart from '../../resources/svgs/Heart.svg'

const size = 18
const actionTypes = {
  add: 'Add',
  remove: 'Remove',
}

export default class FavouriteButton extends PureComponent {
  static propTypes = {
    favourited: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    type: PropTypes.string,
    name: PropTypes.string,
    onFavourited: PropTypes.func,
    notificationElement: PropTypes.instanceOf(Element).isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    withBorder: PropTypes.bool,
    festivalMap: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      favourited: props.favourited || false,
      action: props.favourited ? actionTypes.remove : actionTypes.add,
      showNotification: false,
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      favourited: props.favourited,
      action: props.favourited ? actionTypes.remove : actionTypes.add,
    })
  }

  onFavouriteSuccess = () => {
    const { onFavourited } = this.props
    const { favourited } = this.state

    this.setState(state => ({ ...state, showNotification: favourited }))

    if (onFavourited) {
      onFavourited()
    }
  }

  onFavouriteFail = () => {
    this.setState(state => ({ ...state, favourited: !state.favourited }))
  }

  onButtonClicked = () => {
    const { favourited } = this.state
    const { type, id, name } = this.props

    const action = favourited ? 'Remove' : 'Add'
    const url = `/account/favourites/${action}${type}/${id}?name=${name}`

    this.setState(state => ({
      ...state,
      favourited: !state.favourited,
      action: !favourited ? 'Remove' : 'Add',
    }))

    return api
      .get(url)
      .then(this.onFavouriteSuccess)
      .catch(this.onFavouriteFail)
  }

  onNotificationEnded = () => this.setState({ showNotification: false })

  buttonContent = () => {
    const { action, favourited } = this.state

    const iconClassName = favourited
      ? `${styles['icon']} ${styles['icon--favourited']}`
      : styles['icon']

    return (
      <span className={styles['container']}>
        <Icon
          glyph={heart}
          className={iconClassName}
          width={size}
          height={size}
        />
        <span className={styles['text']}>
          {i18n.get(`Translation.${action}Favourite`)}
        </span>
      </span>
    )
  }

  render() {
    const {
      notificationElement,
      isLoggedIn,
      id,
      name,
      type,
      withBorder,
      festivalMap,
    } = this.props
    const { showNotification, favourited } = this.state

    const linkClassName = withBorder
      ? `${styles['link']} ${styles['link--border']}`
      : styles['link']

    if (isLoggedIn) {
      return (
        <div>
          <button onClick={this.onButtonClicked} className={linkClassName}>
            {this.buttonContent()}
          </button>
          {showNotification && favourited === true
            ? createPortal(
                <FavouriteNotification
                  onEnded={this.onNotificationEnded}
                  festivalMap={festivalMap}
                  shown
                />,
                notificationElement
              )
            : null}
        </div>
      )
    }

    const loginQuery = qs.stringify(
      { id, type, name },
      { addQueryPrefix: true }
    )
    const loginUrl = `/login/addfavourite${loginQuery}`
    return (
      <a href={loginUrl} className={linkClassName}>
        {this.buttonContent()}
      </a>
    )
  }
}
